/* ======================================================================== */
/* 5. elementor-preview */
/* ======================================================================== */
/**
 * Elementor Document Settings
 * Live Preview & Editing
 */
jQuery(window).on('elementor/frontend/init', function () {

	if (typeof elementor !== 'undefined') {

		elementorFrontend.hooks.addAction('frontend/element_ready/global', function ($scope) {
			new LazyLoad({
				scope: $scope
			});
		});
		/**
		 * Version Compare
		 */
		function compareVersion(v1, v2) {
			if (typeof v1 !== 'string') return false;
			if (typeof v2 !== 'string') return false;
			v1 = v1.split('.');
			v2 = v2.split('.');
			const k = Math.min(v1.length, v2.length);
			for (let i = 0; i < k; ++i) {
				v1[i] = parseInt(v1[i], 10);
				v2[i] = parseInt(v2[i], 10);
				if (v1[i] > v2[i]) return 1;
				if (v1[i] < v2[i]) return -1;
			}
			return v1.length == v2.length ? 0 : (v1.length < v2.length ? -1 : 1);
		}

		/**
		 * Reload Preview & Open Panel
		 */
		function updatePreview(openedPageAfter, openedTabAfter, openedSectionAfter) {
			elementor.reloadPreview();
			elementor.once('preview:loaded', () => {
				if (openedPageAfter) {
					elementor.getPanelView().setPage(openedPageAfter);
				}

				if (openedTabAfter) {
					elementor.getPanelView().getCurrentPageView().activeTab = openedTabAfter;
				}

				if (openedSectionAfter) {
					elementor.getPanelView().getCurrentPageView().activateSection(openedSectionAfter);
				}

				elementor.getPanelView().getCurrentPageView().render();
			});
		}

		/**
		 * Reload Elementor Preview
		 */
		function reloadPreview(openedPageAfter, openedTabAfter, openedSectionAfter) {

			// Backward Compatibility for Elementor 2.8.5 or earlier
			if (compareVersion(elementor.config.version, '2.9.0') <= 0) {
				elementor.saver.update({
					onSuccess: () => {
						updatePreview(openedPageAfter, openedTabAfter, openedSectionAfter);
					}
				});
			} else {
				elementor.saver.update().then(() => {
					updatePreview(openedPageAfter, openedTabAfter, openedSectionAfter)
				});
			}

		}


		var
			$header = jQuery('.header'),
			$sectionMasthead = jQuery('.section-masthead'),
			$portfolioDetails = jQuery('.portfolio-details'),
			header = new Header(),
			headerInitialClasses = $header.attr('class'), // cache classes from WP Customizer
			defaultOptions = elementor.settings.page.getSettings().controls, // cache settings from WP Customizer
			currentOptions = elementor.settings.page.model.attributes; // current settings

		/**
		 * Update Masthead
		 */
		function updateMasthead(newval) {

			if (newval == 'yes') {
				$sectionMasthead.addClass('d-none');
			} else {
				$sectionMasthead.removeClass('d-none');
			}

		}

		/**
		 * Update Page Header Settings
		 */
		function updateHeaderSettings(newval) {

			if (newval == 'yes') {
				updateHeaderTheme(currentOptions.page_header_theme);
				updateHeaderPosition(currentOptions.page_header_position);
				updateHeaderSticky(currentOptions.page_header_sticky);
			} else { // reset settings to defaults
				$header.removeAttr('class').addClass(headerInitialClasses);
				updateHeaderTheme(defaultOptions.page_header_theme.default);
				updateHeaderPosition(defaultOptions.page_header_position.default);
				updateHeaderSticky(defaultOptions.page_header_sticky.default);
			}

			// reload preview if menu style was changed to render menu
			if (defaultOptions.page_menu_style.default != currentOptions.page_menu_style) {
				reloadPreview('page_settings', 'settings', 'header_section');
			}

		}

		/**
		 * Update Header Color Theme
		 */
		function updateHeaderTheme(newval) {

			$header.removeClass('header_dark header_light header_accent').addClass(newval);

		}

		/**
		 * Update Header Position
		 */
		function updateHeaderPosition(newval) {

			$header.removeClass('header_relative header_absolute').addClass(newval);
			header.enableSticky(false);
			header.enableSticky(true);
		}

		/**
		 * Update Header Sticky
		 */
		function updateHeaderSticky(newval) {

			if (newval == 'yes') {
				$header.addClass('js-header-sticky');
				header.enableSticky(true);
			} else {
				$header.removeClass('js-header-sticky header_fixed');
				header.enableSticky(false);
			}

		}
		/**
		 * Page Header Settings
		 */
		elementor.settings.page.addChangeCallback('page_header_settings', function (newval) {
			updateHeaderSettings(newval);
		});

		/**
		 * Header Theme
		 */
		elementor.settings.page.addChangeCallback('page_header_theme', function (newval) {
			updateHeaderTheme(newval);
		});

		/**
		 * Header Position
		 */
		elementor.settings.page.addChangeCallback('page_header_position', function (newval) {
			updateHeaderPosition(newval);
		});

		/**
		 * Header Sticky
		 */
		elementor.settings.page.addChangeCallback('page_header_sticky', function (newval) {
			updateHeaderSticky(newval);
		});

		/**
		 * Menu Style
		 */
		elementor.settings.page.addChangeCallback('page_menu_style', function (newval) {
			reloadPreview('page_settings', 'settings', 'header_section');
		});

		/**
		 * Minimal Header (for Portfolio Item post type)
		 */
		elementor.settings.page.addChangeCallback('page_header_minimal', function (newval) {
			reloadPreview('page_settings', 'settings', 'header_section');
		});

		/**
		 * Header Logo Version
		 */
		elementor.settings.page.addChangeCallback('page_header_logo_version', function (newval) {
			reloadPreview('page_settings', 'settings', 'header_section');
		});

		/**
		 * Page Featured Image
		 */
		elementor.settings.page.addChangeCallback('post_featured_image', function (newval) {
			reloadPreview('page_settings', 'settings', 'document_settings');
		});

		/**
		 * Hide Title
		 */
		elementor.settings.page.addChangeCallback('hide_title', function (newval) {
			updateMasthead(newval);
		});

		/**
		 * Page Preloader
		 */
		elementor.settings.page.addChangeCallback('page_preloader_settings', function (newval) {
			reloadPreview('page_settings', 'settings', 'preloader_section');
		});

		/**
		 * Preloader Type
		 */
		elementor.settings.page.addChangeCallback('page_preloader_type', function (newval) {
			reloadPreview('page_settings', 'settings', 'preloader_section');
		});

		/**
		 * Page Footer
		 */
		elementor.settings.page.addChangeCallback('page_footer_settings', function (newval) {
			reloadPreview('page_settings', 'settings', 'footer_section');
		});

		/**
		 * Hide Footer
		 */
		elementor.settings.page.addChangeCallback('page_footer_hide', function (newval) {
			reloadPreview('page_settings', 'settings', 'footer_section');
		});

		/**
		 * Portfolio Item Color Theme
		 */
		elementor.settings.page.addChangeCallback('portfolio_item_color_theme', function (newval) {
			$portfolioDetails.removeClass('bg-dark bg-light bg-white bg-black').addClass(newval);
		});

		/**
		 * Portfolio Next Item
		 */
		elementor.settings.page.addChangeCallback('portfolio_item_show_next', function (newval) {
			reloadPreview('page_settings', 'settings', 'footer_section');
		});

	}

});
